/**
 * Волна D (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute exact path='/stores/:id'>.
 */
import { createFileRoute, notFound } from '@tanstack/react-router';
import CacheDataRoute from '../../CacheDataRoute';
import StorePage from '@routes/Store';
import { getQueryClient } from '../../providers/query';
import { pickupPointByIdQueryOptions } from '@queries/shops';

export const Route = createFileRoute('/stores/$id')({
  /**
   * ЭТАП 2 — честный 404 несуществующей точки самовывоза.
   *
   * ОТЛИЧИЕ от остальных страниц: у этого метода бэк НЕ кидает
   * CONTENT_NOT_FOUND. `deliveryResolver.pickupPointById` на неизвестный id
   * отвечает `null` (`if (!pickUpStores) return null`) — то есть null и есть
   * ответ «такой точки нет», и проверяем мы именно ответ бэка, а не текст
   * ошибки. Нечисловой id отсекаем не отправляя запрос: storeId у метода
   * Int, `+'abc'` ушло бы NaN.
   *
   * Раньше страница в обоих случаях висела в LoadingPage навсегда с кодом
   * 200 (`isLoading = !store`). Клиентская навигация на несуществующую точку
   * по-прежнему упирается в этот вечный лоадер — отдельный SPA-баг, здесь
   * лечится только прямой заход.
   */
  loader: async ({ params }) => {
    if (typeof window !== 'undefined') {
      return;
    }
    const storeId = Number(params.id);
    if (!Number.isInteger(storeId) || storeId <= 0) {
      throw notFound();
    }
    const queryClient = getQueryClient();
    // cartToken пустой — тот же ключ, что и у root-префетча, запрос
    // дедуплицируется
    const options = pickupPointByIdQueryOptions(storeId, '');
    let data;
    try {
      data = await queryClient.ensureQueryData(options);
    } catch {
      // Сетевой сбой — это не «страницы нет»: отдаём страницу как раньше,
      // клиент повторит запрос сам
      return;
    }
    if (!data?.pickupPointById) {
      throw notFound();
    }
  },
  component: () => <CacheDataRoute component={StorePage} path='/stores/:id' />
});
